import { getDefaultExportFromCjs } from './_commonjsHelpers.mjs';
import { __require as requireLodash_merge } from '../node_modules/lodash.merge/index.mjs';

var lodash_mergeExports = requireLodash_merge();
var merge = /*@__PURE__*/getDefaultExportFromCjs(lodash_mergeExports);

export { merge as default };
//# sourceMappingURL=index3.mjs.map
